<template>
   <div class="modal fade" :id="name" tabindex="-1" role="dialog" aria-labelledby="bsModalLabel" data-toggle="modal" data-backdrop="static" data-keyboard="false">
    
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="bsModalLabel">{{ $t('tasklist')[[userType-3]] }} -> {{$t('name')}}:{{patientInfo.name}} ,  {{$t('age')}} : {{new Date().getFullYear() - patientInfo.yob}}  {{$t('years')}}</h4>
        </div>
        <div v-if="loading" class="modal-body center" style="min-height:450px;"><i class="fa fa-spinner fa-spin fa-5x text-primary" aria-hidden="true"></i></div>
        <div class="modal-body" v-else>
         
               <form action="">
                   <div class="input-group" style="width:100%;paddingBottom:15px">
                   
              <input v-model="search.contactNumber"  type="text" :placeholder="`${$t('contactNumber_name')}`" class="input-group-text ">
              <input v-model="search.locationName"  type="text" :placeholder="`${$t('location')}`" class="input-group-text ">
             
              <span v-if="search.userType==3">
             <select v-model="search.userOptionsConsultant" class="input-group-select" >
                  <option value="">{{$t('ConsultantLbl')}}</option>
                  <option v-for="(w, i) in $t('userOptionsConsultant')" :key="i" :value="i">
                           {{w}}
                          </option>
              </select>
              </span>
                <span v-if="search.userType==4">
                 <select v-model="search.userOptionsAmbulance" class="input-group-select">
                  <option value="">{{$t('AmbulanceLbl')}}</option>
                 <option v-for="(w, i) in $t('userOptionsAmbulance')" :key="i" :value="i">
                           {{w}}
                          </option>
                </select>
                  </span>
                  <span v-if="search.userType==5">
               <select v-model="search.userOptionsDelivery" class="input-group-select">
                  <option value="">{{$t('DeliveryLbl')}}</option>
                 <option v-for="(w, i) in $t('userOptionsDelivery')" :key="i" :value="i">
                           {{w}}
                          </option>
                </select>
                  </span>
              <span class="pull-right">
                <button class='btn btn-sm btn-success padding5' @click="searchClick($event)">{{$t('search')}}</button>
                <button class='btn btn-sm btn-success padding5' @click="clearClick($event)">{{$t('clear')}}</button>
                </span>
         
                </div>
                 	<div class="form-group">
                     <div class="scrollbar scrollbar-black bordered-black square"  style="max-height:250px;overflow:auto">
 
                  <table class="table table-striped">
                    <tbody>
                     <tr>
                        <th>{{ $t('name') }} </th>
                        <th>{{ $t('contactNumber') }} </th>
                       
                        <th>{{ $t('optionsLbl') }} </th>
                        <th>{{ $t('cases') }} </th>
                        <th>{{ $t('action') }} </th>
                     </tr>

                    <tr v-for="usr in forwards" :key="usr.id">
                  
                      <td>{{ usr.name }}/{{ usr.locationName }}</td>
                      <td>{{ usr.contactNumber }}</td>
                    
                     
                      <td>
                        <span v-if="search.userType==3">
                            <i v-for="(w, i) in $t('userOptionsConsultant')" :key="i">
                                    {{ usr.userOptionsConsultant.indexOf(i) >= 0 ? w : ''}}
                            </i>
                      </span>
                 <span v-if="search.userType==4">
                  
                      <i v-for="(w, i) in $t('userOptionsAmbulance')" :key="i">
                              {{ usr.userOptionsAmbulance.indexOf(i) >= 0 ? w : ''}}
                      </i>
                 </span>
                 <span v-if="search.userType==5">
                      <i v-for="(w, i) in $t('userOptionsDelivery')" :key="i">
                              {{ usr.userOptionsDelivery.indexOf(i) >= 0 ? w : ''}}
                      </i>
                 </span>
                </td>
                <td>{{ usr.activeCases }}</td>
                <td><input type="radio" :value="usr.id" @change="selectThis(usr)" name="fuser" ></td>
            </tr>
            </tbody>
        </table>

</div>

</div>
                    
             
	<div class="form-group">

  <strong>{{$t('warning')}}</strong>
                      <ul class="list-group" v-if="search.userType==3">
                        <li class="list-group-item" v-for="(s, i) in $t('consultantTasks')" :key="i">
                            <label>
                            
                            <input  
                                type="checkbox"
                                v-model="taskForward.taskType"
                                :value="i"/>
                            {{s}}
                            </label>
                        </li>
                      </ul>
                      <ul class="list-group" v-if="search.userType==4">
                        <li class="list-group-item" v-for="(s, i) in $t('ambulanceTasks')" :key="i">
                            <label>
                            
                            <input  
                                type="checkbox"
                                v-model="taskForward.taskType"
                                :value="i"/>
                            {{s}}
                            </label>
                        </li>
                      </ul>
                      <ul class="list-group" v-if="search.userType==5">
                        <li class="list-group-item" v-for="(s, i) in $t('deliveryTasks')" :key="i">
                            <label>
                            
                            <input  
                                type="checkbox"
                                v-model="taskForward.taskType"
                                :value="i"/>
                            {{s}}
                            </label>
                        </li>
                      </ul>
    
</div>

	<div class="form-group">

    <select v-model="taskForward.priority" class="form-control" :placeholder="`${$t('priorityLbl')}`">                   
        <option v-for="(s, i) in $t('priorityData')" :key="i" :value="i">
        {{s}}
        </option>
    </select>
    
</div>
<div class="form-group">
        <input type="text"  v-model="taskForward.comments" name="comments"  class="form-control my-input" id="comments" :placeholder="`${$t('comments')}`">
</div>
                 
    <div class="text-center">
        <button type="button" class="btn btn-success " @click="submit($event)">{{$t('submit')}}</button>
    </div>
                
                  <div class="alert alert-danger padding5" v-if="error.length>0">{{error}}</div>
               
               </form>
        </div>
        <div class="modal-footer">
          
        </div>
      </div>
    </div>
  </div>     
</template>


<script>
import { services } from '../../src/vuex/api'
import i18n from '../plugins/i18n' 
export default {
  name: 'TaskForm',
  props: {
     patientInfo: Object,
     name: String,
     userType : Number
  },
  watch : {
    userType : function (value) {
        var self = this
        self.taskForward.contactNumber = ''
        self.taskForward.taskType = []
        self.taskForward.taskGroup = -1
        self.taskForward.comments = ''
        self.search.userType = self.userType
        this.getForwardUsers()
    }
  },
   mounted: function () {
      if ( localStorage.getItem('lan') != null ) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language
    },
  data () {
    return {
         error:'',
         loading:false,
        task:[],
        taskInfo:[],
        files:[],
        forwards: [],
        search:{
          contactName:'',
          contactNumber:'',
          userType:3,
          locationX:0,
          locationY:0,
          userOptionsConsultant:-1,
          userOptionsAmbulance:-1,
          userOptionsDelivery:-1
        },
       taskForward:{
          contactNumber:'',
          patientId:'',
          patientName:'',
          patientContact:'',
          taskGroup:-1,
          taskType:[],
          priority:-1,
          comments:''
       },
  }
  },
  methods: {
      selectThis(usr){
      this.taskForward.contactNumber = usr.contactNumber
      this.taskForward.patientId = this.patientInfo.id
      this.taskForward.patientName = this.patientInfo.name
      this.taskForward.patientContact = this.patientInfo.contactNumber
      this.taskForward.taskGroup = usr.userType
    },
    submit(e){
       var self = this
     self.loading = true 
     e.preventDefault()
     self.loading = true
     services.Task.addTask(this.taskForward) //  .getPatientInfo()
    .then(function (response) {
    self.error = '' 
    self.loading = false
    $('#bsForward').modal('hide')
   
     // self.getTask({})
    })
    .catch(function (err) {
     self.loading = false
     self.error = '' + err
    })
    },
     getForwardUsers: function ( ) {
    var self = this
    self.loading = true
     if (self.userType !== 3){
       self.search.locationX = self.patientInfo.location.coordinates[0]
       self.search.locationY = self.patientInfo.location.coordinates[1]
     }
     services.user.getForwardUserList(self.search) //  .getPatientInfo()
    .then(function (response) {
      // console.log(JSON.stringify(response.data))
      self.forwards = response.data.docs
      // self.loading = false 
       self.loading = false
    })
    .catch(function (err) {
      self.loading = false
     self.error = '' + err
    })
  },
   searchClick: function (e){
      e.preventDefault()
    this.getForwardUsers()
  },
  clearClick: function (e){
    e.preventDefault()
  },
  },
}

</script>



// WEBPACK FOOTER //
// TaskForm.vue?6f82664c